import request from '../../src/state/modules/axios'

export function getSchoolVacancyApplications(params){
    return request({
        url: '/api/vacancy-applications',
        method: 'get',
        params,
    })
}

export function getSchoolFVacancyApplications(params){
    return request({
        url: '/api/fvacancy-applications',
        method: 'get',
        params,
    })
}

export function getGlobalApplications(params) {
    return request({
        url: '/api/global-vacancy-applications',
        method: 'get',
        params,
    })
}

export function getSchoolVacancyApplicationsById(data){
    return request({
        url: `/api/vacancy-applications/${data.id}`,
        method: 'get',
    })
}

export function addSchoolVacancyApplications(data){
    return request({
        url: '/api/vacancy-applications',
        method: 'post',
        data,
    })
}

export function editSchoolVacancyApplications(data){
    return request({
        url: `/api/vacancy-applications/${data.id}`,
        method: 'put',
        data,
    })
}

export function deleteSchoolVacancyApplications(data){
    return request({
        url: `/api/vacancy-applications/${data.id}`,
        method: 'delete'
    })
}

export function callUserToTest(data) {
    return request({
        url:'/api/vacancy-applications/call-user-to-test',
        method: "post",
        data,
    })
}

export function haveAccessToTest(data) {
    return request({
        url: '/api/vacancy-applications/access-to-test',
        method:'post',
        data,
    })
}

export function updateApplicationStatus(data){
    return request({
        url:'/api/update-application-status',
        method:'put',
        data,
    })
}

export function getGlobalFApplications(params) {
    return request({
        url: '/api/global-fvacancy-applications',
        method: 'get',
        params,
    })
}

export function addSchoolFVacancyApplications(data){
    return request({
        url: '/api/fvacancy-applications',
        method: 'post',
        data,
    })
}
